import { getSetting } from '@/helpers/tools';
import Auth from '@/api/auth';

let timeoutId;

export default {
  namespaced: true,
  state: {
    isSending: false,
    sentCount: 0,
    timedOut: false,
  },
  mutations: {
    RESTART_TIMER(state) {
      state.timedOut = false;
    },
    STOP_TIMER(state) {
      state.timedOut = true;
    },
    SEND_CODE(state) {
      state.isSending = true;
    },
    SEND_CODE_SUCCESS(state) {
      state.isSending = false;
      state.sentCount += 1;
    },
    SEND_CODE_ERROR(state) {
      state.isSending = false;
    },
  },
  actions: {
    restartTimer({commit}) {
      commit('RESTART_TIMER');

      window.clearTimeout(timeoutId);

      timeoutId = window.setTimeout(() => { commit('STOP_TIMER') }, getSetting('AUTH_CODE_RESEND_TIMEOUT'));
    },
    async sendCode({ commit, dispatch }, { promise }) {
      commit('SEND_CODE');

      try {
        const result = await promise;
        commit('SEND_CODE_SUCCESS');
        dispatch('restartTimer');
        return result;
      } catch (e) {
        commit('SEND_CODE_ERROR');
      }
    },
    async sendCodeForLogin({ dispatch }, { email, password }) {
      return await dispatch('sendCode', { promise: Auth.login(email, password) });
    },
    async sendCodeForSignup({ dispatch }, { mobilePhone }) {
      return await dispatch('sendCode', { promise: Auth.sendCode(mobilePhone) });
    },
    async verifyCode({ commit, dispatch }, { code, save }) {
      await dispatch('authCode/restartTimer');

      try {
        await Auth.verifyAuthCode(code, save);
      } catch(e) {
        await dispatch('authCode/forceTimeout');
        throw e;
      }
    }
  },
  getters: {
    maxAttemptsReached(state) {
      return state.timedOut && state.sentCount >= getSetting('AUTH_CODE_MAX_ATTEMPTS');
    },
    canSendCode(state) {
      return !state.isSending && state.timedOut && state.sentCount < getSetting('AUTH_CODE_MAX_ATTEMPTS');
    },
  },
};
